export default __webpack_public_path__ + "static/blog-cta-lady-fc74600942c0ee387e2a12747c5215ca.jpg";